import { SupplierFields } from "@/config/fields/suppliers";

export default {
  country: SupplierFields.country,
  subjur: SupplierFields.subjur,
  city: SupplierFields.city,
  region: SupplierFields.region,
  op_area: SupplierFields.op_area,
};
